export class ListVaultBlockedRegionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<CloudRegion>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListVaultBlockedRegionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
